export const ADD_SUCCESS = 'Новый коннектор добавлен';
export const ADD_ERROR = 'Не удалось добавить коннектор';
